export function valueLabelFormat(value: number, sufix: string) {
  const units = [sufix];

  let unitIndex = 0;
  let scaledValue = value;

  while (scaledValue >= 1024 && unitIndex < units.length - 1) {
    unitIndex += 1;
    scaledValue /= 1024;
  }

  return `${scaledValue} ${units[unitIndex]}`;
}

export function calculateValue(value: number) {
  return 2 ** value;
}
